type DownloadTask = {
  task: () => Promise<void>,
  priority: number // 0=highest
}
// Promise는 비동기 작업의 결과를 나중에 알려주는 객체

class DownloadQueue {
  private queue: DownloadTask[] = [];
  private workingCount = 0;
  private maxConcurrency = 8;

  // enqueuePreview(task: DownloadTask) {
  //   this.queue.push(task);
  //   this.processQueue();
  // }

  // enqueueOriginal(task: DownloadTask) {
  //   this.queue.unshift(task);
  //   this.processQueue();
  // }
  enqueue(task: () => Promise<void>, priority: number = 100) {
    this.queue.push({ task, priority });
    // 항상 우선순위 기준으로 정렬 (오름차순: 0이 최상위)
    this.queue.sort((a, b) => a.priority - b.priority);
    this.processQueue();
  }

  private async processQueue() {
    while (this.workingCount < this.maxConcurrency && this.queue.length > 0) {
      const {task} = this.queue.shift()!;
      // if (task) {
        this.workingCount++;
        task()
          .catch((error) => {
            console.error('Download task error:', error);
          })
          .finally(() => {
            this.workingCount--;
            this.processQueue();
          });
      // }
    }
  }

  // Study1에 들어갔다가 바로 다시 나오고 Study2에 들어갈 때의 상황을 생각하여 isIdle과 clearQueue를 사용하여 불필요한 것 데이터 다운 방지
  isIdle() {
    return this.workingCount === 0 && this.queue.length === 0;
  }

  hasPriority(priority:number) {
    return this.queue.some((task)=>task.priority===priority)
  }

  clearSpecificPriority(targetPriority:number) {
    this.queue = this.queue.filter((task)=>task.priority!==targetPriority)
    // this.queue = [];
  }

  clearQueue() {
    this.queue = [];
  }
}

export const downloadQueue = new DownloadQueue()
